export const SELF_ONBOARDED_COMPANY_NAME = 'Other > Add a new company';
